// extracted by mini-css-extract-plugin
export default {"container":"SubmitSucces_container__eG69k","content":"SubmitSucces_content__xzsPI"};